// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../../common/utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../../common/utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.utils);
    global.Base = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.inputClasses = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var inputClasses = _exports.inputClasses = (0, _utils.cn)('cop-bg-background', 'cop-border-solid', 'cop-border', 'cop-box-border', 'disabled:cop-cursor-not-allowed', 'disabled:cop-opacity-50', 'file:cop-bg-transparent', 'file:cop-border-0', 'file:cop-font-medium', 'file:cop-text-sm', 'cop-flex', 'focus-visible:cop-outline-none', 'focus-visible:cop-ring-2', 'focus-visible:cop-ring-offset-2', 'focus-visible:cop-ring-ring', 'focus:cop-ring-black', 'cop-font-body', 'cop-h-10', 'placeholder:cop-text-muted-foreground', 'cop-px-3', 'cop-py-0', 'cop-ring-offset-background', 'cop-rounded-md', 'cop-text-sm', 'cop-w-full');
});
